export default __webpack_public_path__ + "static/media/LogoVertical.7cc7ec84.svg";